import { BasketItem } from "../../../../models/BasketItem";

export interface SurveyDraft {
  fingerprint: string;
  currentIndex: number;
  allAnswers: Record<string, string>[];
}

const storageKey = (facilityIds: string): string => `basketSurveyDraft:${facilityIds}`;

// Uwaga: celowo NIE uwzględniamy tu `validFrom` (string z backendu), bo jego format/precyzja
// potrafiła się różnić między dwoma kolejnymi pobraniami koszyka (np. po powrocie ze strony
// "Dodaj uczestnika"), przez co identyczny koszyk dawał inny fingerprint i draft był bezpowrotnie
// tracony. `assortIds:qnt` wystarcza jako "czy to wygląda na tę samą ankietę".
export const buildSurveyDraftFingerprint = (basket: BasketItem[]): string => {
  return basket
    .filter((item) => item.hasSurvey)
    .map((item) => `${item.assortIds}:${item.qnt}`)
    .sort()
    .join("|");
};

/**
 * Zwraca draft zapisany dla danej placówki, bez filtrowania po fingerprincie —
 * o tym, czy draft nadal pasuje do bieżącego koszyka (fingerprint / długość odpowiedzi),
 * decyduje wołający (`useBasketSurvey`), bo tylko on wie, czy warto jeszcze poczekać
 * na ustabilizowanie się danych, zanim bezpowrotnie skasuje zapisane odpowiedzi.
 */
export const loadSurveyDraft = (facilityIds: string): SurveyDraft | null => {
  try {
    const key = storageKey(facilityIds);
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as SurveyDraft;
    if (
      !parsed ||
      typeof parsed.fingerprint !== "string" ||
      !Array.isArray(parsed.allAnswers) ||
      typeof parsed.currentIndex !== "number"
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const saveSurveyDraft = (facilityIds: string, draft: SurveyDraft): void => {
  if (!draft.fingerprint) return;

  try {
    const key = storageKey(facilityIds);
    sessionStorage.setItem(key, JSON.stringify(draft));
  } catch {
    // Quota exceeded or private mode — do not block survey UI
  }
};

export const clearSurveyDraft = (facilityIds: string): void => {
  try {
    const key = storageKey(facilityIds);
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
};
